<div class="thumbnail-drawer" 
     [class.visible]="isVisible" 
     [class.pinned]="isPinned"
     (mouseleave)="onMouseLeave()">
  <div class="drawer-header">
    <h4>Captured Photos</h4>
    <div class="drawer-header-actions">
      <button class="pin-drawer-btn" 
              [class.pinned]="isPinned"
              (click)="onTogglePin()"
              [pTooltip]="isPinned ? 'Unpin drawer (auto-close on leave)' : 'Pin drawer open (stay visible)'"
              tooltipPosition="bottom">
        <i class="pi" [ngClass]="isPinned ? 'pi-lock' : 'pi-lock-open'"></i>
      </button>
      <button class="close-drawer-btn" 
              (click)="onClose()"
              pTooltip="Close drawer"
              tooltipPosition="bottom">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>
  
  <div class="drawer-toolbar">
    <button class="action-btn capture-btn" 
            (click)="onCapturePhoto()"
            pTooltip="Take Photo"
            tooltipPosition="bottom">
      <i class="pi pi-camera"></i>
      <span>Capture</span>
    </button>
    <button class="action-btn gallery-btn" 
            (click)="onOpenFullGallery()"
            pTooltip="Open Full Gallery"
            tooltipPosition="bottom">
      <i class="pi pi-images"></i>
      <span>Gallery</span>
    </button>
  </div>
  
  <div class="drawer-content">
    <div class="media-count" *ngIf="media.length > 0">
      <span>{{ media.length }} {{ media.length === 1 ? 'item' : 'items' }}</span>
    </div>
    
    <div class="thumbnail-grid" *ngIf="media.length > 0; else emptyState">
      <div class="thumbnail-item" *ngFor="let item of media; trackBy: trackByMediaId">
        <div class="thumbnail-image-wrapper">
          <img [src]="getMediaUrl(item)" 
               [alt]="item.name"
               class="thumbnail-image"
               loading="lazy">
          <div class="thumbnail-overlay">
            <i class="pi" [ngClass]="{
              'pi-image': item.type === 'photo' || item.type === 'image',
              'pi-video': item.type === 'video'
            }"></i>
          </div>
        </div>
        <div class="thumbnail-info">
          <span class="thumbnail-time">{{ formatTimestamp(item.createdAt) }}</span>
        </div>
      </div>
    </div>
    
    <ng-template #emptyState>
      <div class="empty-state">
        <i class="pi pi-camera"></i>
        <p>No photos captured yet</p>
        <small>Capture photos during your session</small>
      </div>
    </ng-template>
  </div>
</div>

